if (!customElements.get('horizontal-scroll')) {
  class HorizontalScroll extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.horizontal-scroll__list');
      this.items = [...this.querySelectorAll('.horizontal-scroll__list > li')];
      this.enableGsapAnimation = this.hasAttribute('data-animate-on-entry');
      this.stickyScroll = this.hasAttribute('data-sticky-scroll');
    }

    connectedCallback() {
      this.enableScrollNavigation();
      this.animationOnEntry();
      this.stickyScrollAnimation();
    }

    enableScrollNavigation() {
      if(this.stickyScroll) return;

      const leftArrow = this.querySelector('.scroll-navigation__left');
      const rightArrow = this.querySelector('.scroll-navigation__right');
      const scrollAmount = () => this.offsetWidth * 0.4;

      const updateArrows = () => {
        const scrollLeft = Math.round(this.list.scrollLeft);
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;

        leftArrow.classList.toggle('disabled', scrollLeft <= 0);
        rightArrow.classList.toggle('disabled', scrollLeft >= maxScroll - 1);
      };

      updateArrows();
      this.list.addEventListener('scroll', updateArrows, { passive: true });

      [leftArrow, rightArrow].forEach((arrow, index) =>
        arrow.addEventListener('click', () =>
          this.list.scrollBy({
            left: scrollAmount() * (index ? 1 : -1),
            behavior: 'smooth'
          })
        )
      );
    }

    animationOnEntry() {
      if (!this.enableGsapAnimation) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        }
      });

      tl.from(this.items, {
        y: 100,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        ease: 'power3.out'
      });
    }

  stickyScrollAnimation() {
    if (!this.stickyScroll) return;

    ScrollTrigger.matchMedia({
      "(min-width: 1025px)": () => {

        const scrollDistance = this.list.scrollWidth - this.clientWidth;
        gsap.set(this, { height: `${scrollDistance + window.innerHeight}px` });

        const tween = gsap.to(this.list, {
          x: -scrollDistance,
          ease: "none",
          scrollTrigger: {
            trigger: this,
            start: "top top",
            end: () => `+=${scrollDistance}`,
            scrub: 1,
            invalidateOnRefresh: true
          }
        });

        return () => {
          if (tween.scrollTrigger) tween.scrollTrigger.kill();
          tween.kill();
          gsap.set(this, { clearProps: 'height' });
          gsap.set(this.list, { clearProps: 'x' });
        };
      }
    });
  }

    disconnectedCallback() {
      ScrollTrigger.getAll().forEach(st => {
        if (st.trigger === this) st.kill();
      });
    }

  }
  customElements.define('horizontal-scroll', HorizontalScroll);
}